import { render } from "./AttachedRecord.vue?vue&type=template&id=e125a5ac"
import script from "./AttachedRecord.vue?vue&type=script&lang=js"
export * from "./AttachedRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__